// @flow

// eslint-disable-next-line no-unused-vars
import React, { Fragment } from 'react';
import { last } from 'lodash';

import { NextButton } from '@zapier/product-get-help'; // HelloSection
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import FormNode from 'app/get-help/components/Form/Node';
import useTrackPath from 'app/get-help/hooks/useTrackPath';

import type { Node } from 'react';

import type { FormActions } from 'app/get-help/components/Form/types';
import type { SelectedNode } from 'app/get-help/utils/tree/types';
import type { States } from 'app/get-help/components/Form/machine';
import {
  CSS_CONTAINER_DEFAULT_PADDING,
  CSS_CONTAINER_MAX_WIDTH,
} from 'app/get-help/constants';

import { handleCampaign as maybeTriggerAdaCampaign } from 'app/get-help/utils/ada';

/** @jsx isolateComponent */

type Props = {
  actions: FormActions,
  nodes: SelectedNode[],
  state: States,
};

const Styles = labelStyles(__filename, {
  questions: {
    display: 'grid',
    gridRowGap: 40,
  },
  containerWrapper: {
    maxWidth: CSS_CONTAINER_MAX_WIDTH,
    margin: '40px auto 0px',
  },
  nextWrapper: {
    maxWidth: CSS_CONTAINER_MAX_WIDTH,
    padding: CSS_CONTAINER_DEFAULT_PADDING,
    margin: '0px auto',
  },
});

const Questions = ({ actions, nodes, state }: Props): Node => {
  const trackPath = useTrackPath();

  const questionNodes = nodes.filter(node => node.id !== 'help');
  const isConfirming = state === 'confirm';

  const lastQuestionNode = last(questionNodes);
  const additionalPath = isConfirming ? 'confirm' : '';
  trackPath(lastQuestionNode.pathId, additionalPath);

  const isNextButtonDisabled = !isConfirming;

  // If NextButton is enabled, trigger Ada Campaign
  if (!isNextButtonDisabled) {
    maybeTriggerAdaCampaign(nodes);
  }

  return (
    <Fragment>
      {questionNodes.map(node => (
        <FormNode
          actions={actions}
          key={node.pathId}
          node={node}
          state={state}
        />
      ))}
      {isConfirming && (
        <div css={Styles.nextWrapper}>
          <NextButton onClick={actions.confirm} />
        </div>
      )}
    </Fragment>
  );
};

export default Questions;
